import { useEffect, useRef, useState } from 'react';

export const useLazyLoad = (onLoad, options = {}) => {
  const targetRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const hasLoadedRef = useRef(false);

  useEffect(() => {
    if (hasLoadedRef.current) return;

    const observerOptions = {
      root: options.root || null,
      rootMargin: options.rootMargin || '100px',
      threshold: options.threshold || 0.01,
    };

    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;
      
      if (entry.isIntersecting && !hasLoadedRef.current) {
        hasLoadedRef.current = true;
        setIsVisible(true);
        
        if (onLoad) {
          onLoad();
        }
        
        observer.unobserve(entry.target);
      }
    }, observerOptions);

    const currentRef = targetRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [onLoad, options.root, options.rootMargin, options.threshold]);

  return { targetRef, isVisible };
};